/** 禮遇狀態 */
export enum FlightScheduleType {
  /** 差旅人員安排 */
  T = 'T',
  /** 秘書安排 */
  E = 'E'
}
